import React from "react"
import Socials from "./components/Socials"
import Main from "./components/Main"

export default function App() {
    return (
        <div className="business-card">
            <Main />
            <Socials />
        </div>
    )
}